import styled from 'styled-components';
import generateBackgroundColor from 'utils/generateColor';

const calculateFontSize = ({ count, baseSize }) => {
  const sizeWithoutPx = baseSize.replace('px', '');
  const slope = (count - 1) * 3.5;

  return `${sizeWithoutPx - slope}px`;
};

export const StyledBoardAvatar = styled.section(
  ({ isLoader, count, theme, colorId }) => {
    const {
      colors: { iconBackgrounds: colorsArr, text },
      font,
      border,
    } = theme;
    const { isDark, color } = generateBackgroundColor(colorId, colorsArr);
    const textColor = isDark ? text.tertiary : text.primary;
    const bgColor = isLoader ? 'none' : color;
    const fontSize = isLoader
      ? 0
      : calculateFontSize({ baseSize: '20px', count });

    return {
      alignItems: 'center',
      background: bgColor,
      borderRadius: border.radius.sm,
      color: textColor,
      display: 'flex',
      flexShrink: 0,
      fontSize,
      fontWeight: font.weight.bold,
      height: '36px',
      justifyContent: 'center',
      lineHeight: font.lineHeight.md,
      position: 'relative',
      textTransform: 'uppercase',
      userSelect: 'none',
      width: '36px',
    };
  },
);

export const StyledSkeletonLoader = styled.aside({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
});
